export const environment = {
  configApiURL: 'https://tymes4-v2-app-prod-api-fanmanagement.azurewebsites.net/v2/',
  production: true
};
